/**
 * The CURRENT MEDICATIONS line of the patient's downloadable medical report.
 *
 * ★★★ MED-REPORT-EMPTY-1 — this line read `meds.medicationList`, A KEY THAT EXISTS NOWHERE
 *   IN THE APP. Every other reader uses `meds.list` (visitPrepPDF, profileFormat, and the
 *   sibling `formatMedications` in this very screen). The undefined key fell through to the
 *   empty branch, so the PDF A PATIENT HANDS TO A DOCTOR has always said "None reported"
 *   under CURRENT MEDICATIONS regardless of what they take.
 *
 * ★★★ IT LIVES HERE, NOT IN A TEMPLATE LITERAL, BECAUSE A DECISION INSIDE AN INTERPOLATION
 *   CANNOT BE GATED (§1cd(f)). It is pure: no React, no clock, no I/O.
 *
 * ** THREE ANSWERS, NOT TWO. `hasMedications === false` is the patient SAYING no; an empty
 *   list with no assertion is NOBODY ASKED. They must not print the same sentence on a
 *   clinical document (D300, and the API mirror now stores `null` for the third case).
 */
export function currentMedicationsLine(meds) {
  if (!meds || typeof meds !== 'object') return 'Not documented'
  if (meds.hasMedications === false) return 'No current medications'
  const list = Array.isArray(meds.list) ? meds.list : []
  if (list.length === 0) return 'Not documented'
  return list
    .filter(m => m && m.name)
    .map(m => `${m.name}${m.dosage ? ' ' + m.dosage : ''}${m.frequency ? ' - ' + m.frequency : ''}`)
    .join('; ') || 'Not documented'
}
